<template>
    <el-dialog
        class="ssm-warehouse-operate-dialog"
        :title="(currentId ? '编辑' : '新增') + '仓库闲置人员'"
        :visible.sync="visible"
        :close-on-click-modal="false"
        top="4%"
        width="980px"
        :before-close="close">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="mini">
            <el-row>
                <el-col :span="8">
                    <el-form-item prop="provinceCode" label="仓库省份">
                        <el-select v-model="form.provinceCode" clearable @change="handleProvinceChange">
                            <el-option
                                v-for="option in provinceOptions"
                                :key="option.label + '_' +option.value"
                                :label="option.label"
                                :value="option.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="cityCode" label="仓库城市">
                        <el-select v-model="form.cityCode" clearable :disabled="!form.provinceCode" @change="handleCityChange">
                            <el-option
                                v-for="option in cityOptions"
                                :key="option.label + '_' +option.value"
                                :label="option.label"
                                :value="option.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="areaCode" label="仓库区县">
                        <el-select v-model="form.areaCode" clearable :disabled="!form.cityCode" @change="handleAreaChange">
                            <el-option
                                v-for="option in areaOptions"
                                :key="option.label + '_' +option.value"
                                :label="option.label"
                                :value="option.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item prop="warehouseArea" label="仓库整体面积/m²">
                        <el-input v-model.trim="form.warehouseArea" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="warehouseRentableArea" label="仓库可租面积/m²">
                        <el-input v-model.trim="form.warehouseRentableArea" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="warehouseType" label="仓库类型">
                        <MSelect
                            :value="form.warehouseType"
                            multiple
                            @input="val => handleChange(val, 'warehouseType')"
                            :optionNum="'SYS_SU_WH_TYPE'"
                        />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item prop="warehouseFireProtectionLevel" label="消防验收">
                        <MSelect
                            :value="form.warehouseFireProtectionLevel"
                            @input="val => handleChange(val, 'warehouseFireProtectionLevel')"
                            :optionNum="'SYS_SU_FIRE_INSPECTION'"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="bottomPrice" label="最低价/元/月">
                        <el-input v-model.trim="form.bottomPrice" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="maximumPrice" label="最高价/元/月">
                        <el-input v-model.trim="form.maximumPrice" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item prop="warehouseOwnerName" label="仓库业主名称">
                        <el-input v-model.trim="form.warehouseOwnerName" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="contacts" label="联系人">
                        <el-input v-model.trim="form.contacts" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="contactNumber" label="联系电话">
                        <el-input v-model.trim="form.contactNumber" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item prop="warehousePictureUrl" label="仓库图片" class="upload-item">
                        <!-- <el-input v-model.trim="form.warehousePictureUrl" placeholder="请输入"></el-input> -->
                        <el-input v-model="form.warehousePictureUrl" clearable @input="clearPic">
                            <template slot="append">
                                <upload
                                    :accept="accept"
                                    :fileTypeReg="fileTypeReg"
                                    @uploadSuccess="handleUpload"
                                ></upload>
                            </template>
                        </el-input>
                        <el-button v-if="form.warehousePictureUrl" type="text" size="mini" class="preview-btn" @click="handlePreview">预览</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="rentableFlag" label="是否可租">
                        <MSelect
                            :value="form.rentableFlag"
                            @input="val => handleChange(val, 'rentableFlag')"
                            :optionNum="'SRM_PHY_WH_ENABLE_LEASE'"
                        />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="comfirm">保存</el-button>
            <el-button v-if="form.rentableFlag === '1'" type="primary" :loading="pubLoading" @click="publish">保存并发布</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { getCitys, getDistricts } from '../../../utils/getArea.js'
import { getWarehouseIdleResources, addWarehouseIdleResources, editWarehouseIdleResources, releaseWarehouseIdleResources } from '../../../api/storageSupManage/idleResource.js';
import { getPersons } from '../../../api/register/person.js';
import { phoneVerify } from '../../../constant/formRegular.js';
import MSelect from '@/components/lots/otpSelect2/index.vue';
import Upload from '../../../components/upload/Index.vue';

const INITFORM = {
    provinceCode: '',
    cityCode: '',
    areaCode: '',
    provinceName: '',
    cityName: '',
    areaName: '',
    warehouseArea: '',
    warehouseRentableArea: '',
    warehouseType: [],
    warehouseFireProtectionLevel: '',
    bottomPrice: '',
    maximumPrice: '',
    warehouseOwnerName: '',
    contacts: '',
    contactNumber: '',
    warehousePictureUrl: '',
    rentableFlag: '',
};

const NUM_REG = /^(0\.[1-9])$|^([1-9]\d{0,5}(\.\d)?)$/
const NUM_REG_MSG = '支持6位正整数，小数点保留1位'

const RULES = {
    provinceCode: [{ required: true, message: '请选择仓库省份', trigger: ['blur', 'change'] }],
    cityCode: [{ required: true, message: '请选择仓库城市', trigger: ['blur', 'change'] }],
    warehouseArea: [
        { required: true, message: '请输入仓库整体面积', trigger: ['blur', 'change'] },
        { pattern: NUM_REG, message: NUM_REG_MSG, trigger: ['blur', 'change'] },
    ],
    warehouseRentableArea: [
        { required: true, message: '请输入仓库可租面积', trigger: ['blur', 'change'] },
        { pattern: NUM_REG, message: NUM_REG_MSG, trigger: ['blur', 'change'] },
    ],
    warehouseType: [{ required: true, message: '请选择仓库类型', trigger: ['blur', 'change'] }],
    warehouseFireProtectionLevel: [{ required: true, message: '请选择消防验收', trigger: ['blur', 'change'] }],
    bottomPrice: [
        { required: true, message: '请输入最低价', trigger: ['blur', 'change'] },
        { pattern: NUM_REG, message: NUM_REG_MSG, trigger: ['blur', 'change'] },
    ],
    maximumPrice: [
        { required: true, message: '请输入最高价', trigger: ['blur', 'change'] },
        { pattern: NUM_REG, message: NUM_REG_MSG, trigger: ['blur', 'change'] },
    ],
    warehouseOwnerName: [
        { required: true, message: '请输入仓库业主名称', trigger: ['blur', 'change'] },
        { max: 30, message: '限制输入30个字符', trigger: ['blur', 'change'] }
    ],
    contacts: [
        { required: true, message: '请输入联系人', trigger: ['blur', 'change'] },
        { max: 30, message: '限制输入30个字符', trigger: ['blur', 'change'] }
    ],
    contactNumber: [
        { required: true, message: '请输入联系电话', trigger: ['blur', 'change'] },
        { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: ['blur', 'change'] },
    ],
    rentableFlag: [{ required: true, message: '请选择是否可租', trigger: ['blur', 'change'] }],
};

export default {
    components: { MSelect, Upload },
    props: {
        provinceOptions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            currentId: '',
            visible: false,
            form: { ...INITFORM },
            loading: false,
            pubLoading: false,
            // provinceOptions: [],
            cityOptions: [],
            areaOptions: [],
            accept: '.doc,.docx,.pdf,.ppt,.xls,.xlsx,.jpg,.jpeg,.png',
            fileTypeReg: /\.(jpg|jpeg|png|doc|docx|xls|xlsx|pdf|ppt)$/,
        };
    },
    computed: {
        ...mapState(['supplier']),
        ...mapGetters(['user', 'currentTenant']),
        rules() {
            return {
                ...RULES,
                maximumPrice: [
                    { required: true, message: '请输入最高价', trigger: ['blur', 'change'] },
                    { pattern: NUM_REG, message: NUM_REG_MSG, trigger: ['blur', 'change'] },
                    {
                        validator: (rule, value, callback) => {
                            if (Number(value) < Number(this.form.bottomPrice)) {
                                callback(new Error('最高价不能低于最低价'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change']
                    }
                ],
            }
        }
    },
    methods: {
        open(row) {
            this.visible = true;
            if (row) {
                this.currentId = row.id;
                this.load(row);
            } else {
                if (this.supplier) {
                    this.setSupplierContactInfo()
                } else {
                    this.form.contacts = this.user.userName
                    this.form.contactNumber = this.user.mobile
                }
            }
        },
        close() {
            this.currentId = '';
            this.form = { ...INITFORM };
            this.cityOptions = []
            this.areaOptions = []
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
                this.visible = false;
            });
        },
        load(row) {
            getWarehouseIdleResources(row.id).then(res => {
                if (res && +res.code === 0) {
                    Object.keys(this.form).forEach(key => {
                        this.form[key] = key === 'warehouseType' ?
                            (res.data[key] ? res.data[key].split(',') : []) : res.data[key];
                    });
                    this.setRegionOptions()
                }
            }).catch(err => {});
        },
        comfirm() {
            this.$refs.form.validate().then(valid => {
                const operate = this.currentId ?
                    { api: editWarehouseIdleResources, successMsg: '编辑成功!' } :
                    { api: addWarehouseIdleResources, successMsg: '新增成功!' };
                this.loading = true;
                operate.api(this.getParams()).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(operate.successMsg);
                        this.close();
                        this.$emit('refresh');
                    }
                }).finally(() => { this.loading = false; });
            }).catch(err => {});
        },
        publish() {
            this.$refs.form.validate().then(valid => {
                this.pubLoading = true;
                releaseWarehouseIdleResources(this.getParams()).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('保存并发布成功!');
                        this.close();
                        this.$emit('refresh');
                    }
                }).finally(() => { this.pubLoading = false; });
            }).catch(err => {});
        },
        getParams() {
            const params = { ...this.form };
            params.tenantCode = this.currentTenant.tenantCode;
            if (this.currentId) {
                params.id = this.currentId;
                params.updateUserCode = this.user.userCode;
                params.updateUserName = this.user.userName;
            } else {
                params.createUserCode = this.user.userCode;
                params.createUserName = this.user.userName;
            }
            params.warehouseType = params.warehouseType && params.warehouseType.length ? params.warehouseType.join(',') : ''
            return params;
        },
        handleChange(val, prop) {
            this.form[prop] = val;
        },
        setRegionOptions() {
            if (this.form.provinceCode) {
                getCitys(this.form.provinceCode).then(res => {
                    this.cityOptions = res;
                })
            }
            if (this.form.cityCode) {
                getDistricts(this.form.cityCode).then(res => {
                    this.areaOptions = res;
                })
            }
        },
        handleProvinceChange(val) {
            this.form.cityCode = '';
            this.form.areaCode = '';
            this.form.provinceName = val ? this.provinceOptions.find(item => item.value === val).label : '';
            this.form.cityName = '';
            this.form.areaName = '';
            this.cityOptions = [];
            this.areaOptions = [];
            if (val) {
                getCitys(val).then(res => {
                    this.cityOptions = res;
                })
            }
        },
        handleCityChange(val) {
            this.form.areaCode = '';
            this.form.cityName = val ? this.cityOptions.find(item => item.value === val).label : '';
            this.form.areaName = '';
            this.areaOptions = [];
            if (val) {
                getDistricts(val).then(res => {
                    this.areaOptions = res;
                })
            }
        },
        handleAreaChange(val) {
            this.form.areaName = val ? this.areaOptions.find(item => item.value === val).label : '';
        },
        clearPic() {
            this.form.warehousePictureUrl = ''
        },
        handleUpload(val) {
            if (val.data && +val.data.code === 0) {
                // this.form.attachmentFileName = val.data.data.localFileName;
                this.$message.success('上传成功!');
                this.form.warehousePictureUrl = val.data.data.downUrl;
            }
        },
        handlePreview() {
            this.$emit('preview', this.form.warehousePictureUrl)
        },
        setSupplierContactInfo() {
            const params = {
                pageNo: 1,
                pageSize: 99999,
                supplierCode: this.supplier.supplierCode
            }
            getPersons(params).then(res => {
                if (res && +res.code === 0) {
                    // userType=1 为主账号
                    const mainItem = res.data.list.find(item => +item.userType === 1)
                    if (mainItem) {
                        this.form.contacts = mainItem.contacts
                        this.form.contactNumber = mainItem.contactsMobile
                    }
                }
            })
        },
    },
};
</script>
<style lang="less">
.ssm-warehouse-operate-dialog {
    .el-select {
        width: 100%;
    }

    .upload-item .el-input-group__append {
        padding: 0 10px;
    }

    .preview-btn {
        position: absolute;
        right: -34px;
    }
}
</style>